import styled, { css } from 'styled-components';

export const WidgetContainer = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: ${(props) => (props.applied ? '#e6f7e6' : '#f9f9f9')};
  box-shadow: ${(props) => (props.applied ? '0 4px 8px rgba(0, 0, 0, 0.2)' : '0 2px 4px rgba(0, 0, 0, 0.1)')};
  transition: box-shadow 0.3s ease;
`;

export const StatusIconWrapper = styled.div`
  float: right;
`;

export const LinkButton = styled.button`
  background: none !important;
  border: none;
  padding: 0 !important;
  margin: 0 5px;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
  }
`;

export const SpacedRow = styled.div`
  margin: 16px 0px; /* Adjust spacing as needed */
`;

export const Title = styled.div`
  font-size: 18px; /* Adjust spacing as needed */
`;

export const Chip = styled.div`
  display: inline-flex;
  margin-right: 4px;
  align-items: center;
  justify-content: center;
  padding: ${(props) => (props.size === 'small' ? '4px 8px' : '8px 16px')};
  border-radius: 16px;
  background-color: ${(props) => props.bgColor || '#e0e0e0'};
  color: ${(props) => props.textColor || '#333'};
  font-size: ${(props) => (props.size === 'small' ? '12px' : '14px')};
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  box-shadow: ${(props) => (props.elevated ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'none')};
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    background-color: ${(props) => (props.onClick ? props.hoverColor || '#d6d6d6' : props.bgColor)};
    box-shadow: ${(props) => (props.onClick && props.elevated ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none')};
  }
`;

export const ChipLabel = styled.span`
  margin-right: ${(props) => (props.hasIcon ? '2px' : '0')};
`;

export const ChipIcon = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  font-size: ${(props) => (props.size === 'small' ? '12px' : '16px')};
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};

  &:hover {
    opacity: ${(props) => (props.onClick ? '0.7' : '1')};
  }
`;

export const ItalicDescription = styled.div`
  font-style: italic;
  color: #333; /* You can adjust the color */
  font-size: 16px; /* Adjust font size as needed */
`;

export const SectionTitle = styled.div`
    color: #2a2c2e;
    font-size: 1.25rem;
    letter-spacing: -1px;
    line-height: 1.6;
    font-weight: 400;
`;

export const SectionSubTitle = styled.div`
  font-size: 0.8rem;
  font-style: italic;
`;

export const Spacer = styled.div`
    height: 16px;
`;

  export const ActionsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  `

  export const SpinnerContainer = styled.div`
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  `

export const AlertText = styled.div`
  border-radius: 8px; /* Rounded corners */
  padding: 16px; /* Add some spacing inside the box */
  display: flex; /* Flexbox for centering */
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  text-align: center; /* Center text alignment */
  font-size: 16px; /* Adjust text size */
  font-weight: 500; /* Slightly bold text */
  width: 100%;
  margin: 10px 0px;

  ${({ type }) =>
    type === 'error' &&
    css`
      background-color: #ffe5e5; /* Light red background */
      border: 1px solid #ff4d4d; /* Reddish border */
      color: #b30000; /* Darker red for text */
    `}

  ${({ type }) =>
    type === 'warning' &&
    css`
      background-color: #fff8e5; /* Light yellow background */
      border: 1px solid #ffd966; /* Yellowish border */
      color: #b38f00; /* Darker yellow for text */
    `}
`;

// Usage Example
// <AlertText type="error">This is an error message.</AlertText>
// <AlertText type="warning">This is a warning message.</AlertText>
